import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: '共済マイページのユーザー数増加、リニューアル後も継続支援',
  title1: '共済マイページのユーザー数増加、リニューアル後も継続支援',
  introduction_text:
    '加入者向けマイページの全体構築を担当しました。このプロジェクトは、組合員様が「使いやすく安心できる」UIを意識したリニューアルです。弊社が情報設計、デザイン、フロントエンド開発を一貫して担当することでスムーズに構築を実現できました。現在は、共済金請求、割戻金請求、電子通知の受取などのサイト構築も支援しています。',
  company: '日本コープ共済生活協同組合連合会',
  tag1text: 'フロントエンド開発',
  tag1src: '/cases/frontend-dev/',
  tag2text: 'UX/UI改善',
  tag2src: '/cases/uxui-improvement/',
  industryTagText: '金融/不動産',
  industryTagSrc: '/cases/finance/',
  color: '#222222',
  background: '#00BED2',
  staff1: '',
  image: '/images/img/cases/kyosaimypage/top.png',
  alt: '共済マイページのユーザー数増加、リニューアル後も継続支援',
}

// プロジェクト概要
export const overviewTitle = 'ユーザーファーストなUI/UXデザイン向上を継続的にご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '日本コープ共済生活協同組合連合会様（以下、コープ共済連様）の基本的価値にあるのは「相互扶助や協同の精神を育む」という点です。これを伝えるべく、すべての組合員（ユーザー）様が「継続して使いやすい」「使っていて安心する」を感じていただけるUIを意識した、加入者様向け「マイページ」の全体構築を行わせていただきました。',
  },
  {
    text: '当初、コープ共済連様では、マイページの情報設計・デザイン・フロントエンド・バックエンドを複数のベンダーで担当していました。それにより、ベンダー間での煩雑なやりとりやベンダー間でのボタンの掛け違いなどから、プロジェクトがスムーズに進まないことが課題でした。',
  },
  {
    text: 'コープ共済連様から弊社へ「情報設計、デザイン、フロントエンド開発までを一貫して依頼できないか」というご相談をいただき、 現在はマイページのUI/UX向上について、継続的なお手伝いをさせていただいております。',
  },
  {
    text: '主に、共済金請求、割戻金請求、電子通知の受取、などにおける内部試作の実施、ヒューリスティック調査を行っています。',
    nonMargin: true,
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '複数ベンダー間のコミュニケーション問題',
        text: '以前はマイページサイトの情報設計・デザイン・開発を複数のベンダーが担当していたため、ベンダー間での煩雑なやり取りやボタンの掛け違いが発生していた。',
      },
      {
        title: 'ユーザー体験の向上',
        text: 'ユーザーが継続して使いやすく、安心感を持って利用できるUIの実現が求められていた。',
      },
      {
        title: 'サイト全体の統一性と効率化',
        text: '情報設計、デザイン、開発を一貫して担当できるパートナーを求めていたことで、サイト全体の統一性と効率化を実現したいという要望があった。',
      },
    ],
    solutions: [
      {
        title: '一貫したプロジェクト担当',
        text: '情報設計からデザイン、フロントエンド開発までを一貫して担当することで、クライアントとのコミュニケーションを効率化し、プロジェクトをスムーズに進行させることができた。',
      },
      {
        title: 'ユーザー中心のデザイン',
        text: 'ユーザーが安心して使い続けられるよう、ユーザビリティを高めたデザインを提供。また、デザインスプリントやユーザーインタビューを行い、実際のユーザーの声を設計に反映させることで、使い勝手の良いサイトを実現した。',
      },
      {
        title: '継続的なサポートと共同成長',
        text: 'リニューアル後も継続的に改善を行い、クライアントの長期的なパートナーとして機能した。これにより、サイトの運用フェーズでの課題解決やアイデアの実装をサポートし、共に成長する関係を築いた。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'ベンダーが増えるほど、プロジェクトは止まっていませんか？',
  description:
    '情報設計・UX/UIデザイン・フロントエンド開発を一気通貫で担い、ベンダー間の齟齬をなくしてリリース後の継続改善まで伴走します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiuxdesign' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiuxdesign' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
